<!--
	TEMPLATE
-->
<template>
	<div class="editable-item">
		<swiper ref="photosSwiper" v-model="images" class="edit-page__slider-content" :options="swiperOption">
		  <swiper-slide :key="image" v-for="(image, index) in images"><img :src="s3url(image, 'medium')"></swiper-slide>
		  <div class="swiper-pagination edit-page__slider-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
		</swiper>
		<hr />
	</div>
</template>

<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
    props: {
		 value: {
			type: Array,
			default: function() {
			   return []
			}
		 },
	 },
    data: function() {
        return {
			 swiperOption: {
				 loop: true,
				  centeredSlides: true,
				  pagination: {
					  el: '.swiper-pagination',
					  type: 'fraction'
				  },
				  navigation: {
					  nextEl: '.swiper-button-next',
					  prevEl: '.swiper-button-prev'
				  },
	           spaceBetween: 30,
			 }
        }
    },
	 mixins: [utils],
	 components: {
		 'swiper': swiper,
		 'swiperSlide' : swiperSlide
	 },
	 computed: {
 		images: vModelNested
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Slider.vue